import { timeAgo } from '@components/ArtBoard/Threads'
import { UnreadDot } from '@lib/components'
import type React from 'react'

import type { ThreadListItem } from '../../types'
import { LinkActions } from '../LinkActions'
import { ThreadAvatars } from '../ThreadAvatars'
import css from './styles.module.css'

interface Props {
  thread: ThreadListItem
  actionsClassName: string
}

export const LinkHeader: React.FC<Props> = ({ thread, actionsClassName }) => {
  const { commentators, resolved, name, createdAt, active, unread } = thread

  return (
    <div className={css.link_header}>
      <div className={css.avatars_container}>
        <ThreadAvatars
          avatars={commentators}
          active={active}
          resolved={resolved}
        />
      </div>
      <div className={css.labels}>
        <span className={css.name}>{name}</span>
        <span className={css.time_label}>{timeAgo(createdAt)}</span>
      </div>
      {/* the dot and the menu share the right end: an unread row shows the
          dot and has nothing to mark, a read row may show the menu */}
      <div className={css.trailing}>
        {unread && <UnreadDot className={css.unread_marker} />}
        {!unread && (
          <LinkActions thread={thread} className={actionsClassName} />
        )}
      </div>
    </div>
  )
}
